var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCloseModal = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    fillRule: "evenodd",
    d: "M30.607 11.75L22.357 20l8.25 8.25-2.357 2.357-8.25-8.25-8.25 8.25-2.357-2.357 8.25-8.25-8.25-8.25 2.357-2.357L20 17.642l8.25-8.249 2.357 2.357z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseModal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-modal.f94fd6c1.svg";
export { ForwardRef as ReactComponent };